export interface Variant<V, P> {
  value: V | undefined;
  payload: P | null;
}

export interface EnvKey {
  tvg: {
    web: string;
  };
}

export interface KeysList {
  qa: EnvKey;
  staging: EnvKey;
  production: EnvKey;
}

export enum VariantEnum {
  CONTROL = "control",
  TREATMENT = "treatment"
}
